class SignupService {
    constructor($rootScope, $q, Restangular, loginService, shopperService, gtm) {
        this._api = Restangular.one('signup');
        this.gtm = gtm;
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.loginService = loginService;
        this.shopperService = shopperService;
    }

    signup(args) {
        const signupPromise = this._api.doPOST(args);

        const shopperPromise = signupPromise.then(signupResult => (signupResult.Success
            ? this.shopperService.getCurrentShopper()
            : null));

        return this.$q.all([signupPromise, shopperPromise])
            .then(([signupResult]) => {
                if (signupResult.Success) {
                    this.redirectToAgentUrl = signupResult.RedirectToAgentUrl;
                    this.gtm.push({ event: 'signup' });
                    this.loginService.onLogin(signupResult.LoginModel);
                    this.$rootScope.$broadcast('signup:success');
                }

                return signupResult;
            });
    }
}

SignupService.$inject = ['$rootScope', '$q', 'Restangular', 'LoginService', 'ShopperService', 'GtmService'];

module.exports = { SignupService };



// WEBPACK FOOTER //
// ./src/auth/signup/signup.service.js